import React from 'react';
import PropTypes from 'prop-types';
import styles from './StatCard.module.scss';

/* ────────────────────────────────────────────────────────────
 * StatRibbon — horizontal row of StatCards.
 *
 * The companion layout primitive for dashboards / list-screen
 * summaries. Wraps a row of <StatCard> children into a responsive
 * grid that collapses gracefully on small viewports.
 *
 *   <StatRibbon columns={4}>
 *     <StatCard label="Orders" value={1284} />
 *     <StatCard label="Revenue" value={48230} prefix="$" />
 *     <StatCard label="Active items" value={132} />
 *     <StatCard label="Stockouts" value={3} accent="danger" />
 *   </StatRibbon>
 * ──────────────────────────────────────────────────────────── */

const COLUMN_CLASS = {
  2: styles.ribbonCols2,
  3: styles.ribbonCols3,
  4: styles.ribbonCols4,
  5: styles.ribbonCols5,
};

const StatRibbon = ({ columns, children, className }) => {
  const classNames = [styles.ribbon, COLUMN_CLASS[columns], className || '']
    .filter(Boolean)
    .join(' ');
  return <div className={classNames}>{children}</div>;
};

StatRibbon.propTypes = {
  columns: PropTypes.oneOf([2, 3, 4, 5]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

StatRibbon.defaultProps = {
  columns: 4,
  className: '',
};

export default StatRibbon;
